module.exports = __webpack_public_path__ + "static/media/sage.3d7b6a73.webp";